import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initTelemetry } from "./lib/telemetry";
import { initSentry } from "./lib/sentry";

// Initialize error tracking and telemetry (non-blocking)
initSentry();
initTelemetry();

// Initialize theme from localStorage or default to dark
const storedTheme = localStorage.getItem("theme");
if (storedTheme === "light") {
  document.documentElement.classList.remove("dark");
} else {
  document.documentElement.classList.add("dark");
  localStorage.setItem("theme", "dark");
}

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Conditionally wrap with ClerkProvider if key is available
const renderApp = async () => {
  const root = createRoot(document.getElementById("root")!);

  if (CLERK_PUBLISHABLE_KEY) {
    const { ClerkProvider } = await import("@clerk/clerk-react");
    root.render(
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    );
  } else {
    console.warn("VITE_CLERK_PUBLISHABLE_KEY not set — running without auth");
    root.render(<App />);
  }
};

renderApp();
